var Block_Slider_Auto = {
	autoplay_speed:15000,
	currentSlide:0,
	max_slide:0,
	inViewport:false,

	init:function(){
		var _carousel_menu = $(".block-slider-auto .engagements-menu");
		var _carousel_content = $(".block-slider-auto .engagements-content");

		Block_Slider_Auto.max_slide = _carousel_content.find(".item").length;

		_carousel_menu.slick({
			arrows:false, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: 6,
			focusOnSelect: true,
			touchThreshold:500,
			asNavFor:_carousel_content
		});

		_carousel_content.slick({
			arrows:false, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			touchThreshold:500,
			asNavFor:_carousel_menu
		});

		Block_Slider_Auto.start_growing();

		_carousel_content.on('afterChange', function(event, slick, currentSlide, nextSlide){
			Block_Slider_Auto.currentSlide = currentSlide;
			Block_Slider_Auto.start_growing();
		});

		$(window).scroll(function(){
			Block_Slider_Auto.scroll();
		});
		Block_Slider_Auto.scroll();
	},
	scroll:function(){

		var _obj = $(".block-slider-auto .engagements-reveal");

		var _margin = -100;
		var _pos_top = _obj.offset().top - $(window).outerHeight() + _margin;
		var _pos_bottom = (_obj.offset().top + _obj.outerHeight()) - _margin;
		var _pos_scroll = $(window).scrollTop();

		if((_pos_scroll > _pos_top) && (_pos_scroll < _pos_bottom)){

			if(Block_Slider_Auto.inViewport == false){
				Block_Slider_Auto.inViewport = true;
				var _carousel_content = $(".block-slider-auto .engagements-content");
				/*_carousel_menu.slick('slickGoTo', 1);*/
				_carousel_content[0].slick.slickGoTo(0);
			}
		}else{
			if(Block_Slider_Auto.inViewport == true){
				Block_Slider_Auto.inViewport = false;
			}
		}
	},
	start_growing:function(){
		$(".block-slider-auto").find(".progress-barre").stop().css({width:0});
		$(".block-slider-auto").find(".progress-barre.mobile").stop().animate({
			width:"100%"
		}, Block_Slider_Auto.autoplay_speed);
		$(".block-slider-auto .engagements-menu").find(".slick-current .progress-barre").stop().animate({
			width:"100%"
		}, Block_Slider_Auto.autoplay_speed, function(){

			if(Block_Slider_Auto.currentSlide < (Block_Slider_Auto.max_slide-1)){
				Block_Slider_Auto.currentSlide ++;
			}else{
				Block_Slider_Auto.currentSlide = 0;
			}

			$(".block-slider-auto .engagements-content").slick('slickGoTo', Block_Slider_Auto.currentSlide);
		});
	}
}

$(window).load(function(){
	if($(".block-slider-auto").length){
		Block_Slider_Auto.init();
	}
})